angular
  .module('contributor')

  .factory('AssociationCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class Association extends Crud {
        constructor(list) {
          super(
            'association' + (list || ''),
            '@@apiUrl' + '/associations' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return Association;
    }
  ]);
